import { createContext } from "react";

export const PagewideContext = createContext({
    pageContext: {
        carry: {
            clients: {},
        }
    },
    setPageContext: undefined,
});